import type { CompaniesFilterChange } from '@/app/components/hotel-detail/changeTransport/ChangeTransportFiltersCommon';
import { getCompaniesFilterChangeData } from '@/app/components/hotel-detail/changeTransport/ChangeTransportCompaniesFilter';
import { useTransportPageFilterTracking } from '@/app/components/hotel-detail/changeTransport/hooks/useTransportPageFilterTracking';
import { useCuriosity } from '@/app/components/hotel-detail/CuriosityProvider';
import { useUrlSearchParams } from '@/app/components/hotel-detail/UrlSearchParamsProvider';
import {
  EvoCheckboxRow,
  EvoFilterLoadingLayer,
  EvoFilterSection,
} from '@/app/components/hotel-detail/evo/transport/EvoTransportFilters/filters/EvoFilterShared';

type EvoAirlinesFilterProps = {
  companies?: CompanyFilter[];
  onChange: (filterChange: CompaniesFilterChange) => void;
};

export function EvoAirlinesFilter(props: EvoAirlinesFilterProps) {
  const { companies, onChange } = props;
  const { isTrain } = useUrlSearchParams();
  const { sendCuriosityClickEvent } = useCuriosity();
  const sendStratrackFlightPageFilterEvent = useTransportPageFilterTracking();

  if (!companies || companies.length <= 1) return null;

  return (
    <EvoFilterSection>
      {companies.map((company) => (
        <EvoCheckboxRow
          key={company.name}
          id={`evo-airline-${company.name}`}
          label={company.name}
          checked={company.selected}
          disabled={!company.enabled}
          onChange={() =>
            onChange(
              getCompaniesFilterChangeData(
                isTrain,
                companies,
                company.name,
                sendCuriosityClickEvent,
                sendStratrackFlightPageFilterEvent
              )
            )
          }
        />
      ))}
      <EvoFilterLoadingLayer origins={['AIRLINES_FILTER']} />
    </EvoFilterSection>
  );
}
